import { render, staticRenderFns } from "./ChartSignosVitales.vue?vue&type=template&id=08e3976a"
import script from "./ChartSignosVitales.vue?vue&type=script&lang=js"
export * from "./ChartSignosVitales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports